import request from 'app-self-support-order/utils/request'
import api from 'app-self-support-order/common/api/shop-manage'
import {stringify} from 'qs'
import {format} from 'utils'

// 获取店铺列表
export async function getShopList(params) {
    return request(`${api.getShopList.url}?${stringify(params)}`)
}

// 创建店铺
export async function createShop(payload) {
    return request(`${api.createShop.url}`, {
        method: api.createShop.type,
        body: payload.body,
    })
}

// 修改门店信息
export async function editShop(payload) {
    return request(format(`${api.editShop.url}`, {shop_id: payload.id}), {
        method: api.editShop.type,
        body: payload.body,
    })
}
